export default __webpack_public_path__ + "static/mintyourpfp-2f91e9dfd79a2ff63c3c9a36f6381a45.png";